import React from 'react';
import { getAuthorizedMenu, updateMenuRoles } from 'src/store/slices/authorizationSlice';
import RoleAssignmentPanel from 'src/components/RoleAssignmentPanel';

const BASE_COLUMNS = [
  { field: 'MENU_ID', headerName: 'Sıra', width: 80, align: 'center', headerAlign: 'center' },
  { field: 'MENU_NAME', headerName: 'Menü', flex: 1, minWidth: 200 }
];
const SEARCH_FIELDS = ['MENU_NAME'];

function MenuRoleAutho() {
  return (
    <RoleAssignmentPanel
      title="Menü Yetkilendirme"
      unitLabel="menü"
      loadAction={getAuthorizedMenu}
      updateAction={updateMenuRoles}
      buildPayload={(row, roles) => ({ MenuRoles: roles, MenuId: row.MENU_ID })}
      getRowId={(row) => row.MENU_ID}
      baseColumns={BASE_COLUMNS}
      searchFields={SEARCH_FIELDS}
      searchPlaceholder="Menü ara"
      getDialogInfo={(row) => ({ title: row.MENU_NAME, subtitle: 'Menüyü görebilecek roller' })}
    />
  );
}

export default MenuRoleAutho;
